<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Deleted Accounts</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>User</b> /

      <b>Deleted Accounts</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Deleted Accounts
            </h4>
            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="table-responsive">
              <table
                id="tbl_deleted_accounts"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No</th>
                    <th>IC No.</th>
                    <th>Account No.</th>
                    <th>Reason</th>
                    <th>Deleted At</th>
                    <th>Points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in deleted_users" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.ic_number }}</td>
                    <td>{{ user.account_number }}</td>
                    <td>{{ user.delete_reason }}</td>
                    <td>{{ user.deleted_at }}</td>
                    <td>{{ user.points_available }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <br />
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "user-balance",
  components: {
    Loading
  },
  data() {
    return {
      deleted_users: [],
      isLoading: false,
      fullPage: true,
      searchItem: null,
    };
  },
  
  methods: {
    async loadDeletedUsers() {
      if(!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + `/users/deleted`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.deleted_users = result.data.deleted_users;

      } catch (e) {
        console.log(e);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    createDatatable() {
      $("#tbl_deleted_accounts").DataTable({
        pageLength: 15,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              // columns: [0, 1, 2, 3, 4]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              // columns: [0, 1, 2, 3, 4]
            }
          }
        ]
      });
    },

  },

  async created() {
    this.isLoading = true;
    await this.loadDeletedUsers();
    this.isLoading = false;

    this.createDatatable()

  }
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
